import { render, staticRenderFns } from "./WDS2UnitEditor.vue?vue&type=template&id=2b82b4c1&scoped=true"
import script from "./WDS2UnitEditor.vue?vue&type=script&lang=js"
export * from "./WDS2UnitEditor.vue?vue&type=script&lang=js"
import style0 from "./WDS2UnitEditor.vue?vue&type=style&index=0&id=2b82b4c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82b4c1",
  null
  
)

export default component.exports